import type { StyleRules, Theme } from '~/utils/withStyles';

const selectStyles = (theme: Theme) => ({
  chip: {
    margin: `${theme.spacing(0.5)}px ${theme.spacing(0.25)}px`,
  },
  disabled: {
    opacity: 0.55,
  },
  disabledLabel: {
    color: 'rgba(0, 0, 0, 0.6)',
  },
  input: {
    color: 'inherit',
    display: 'flex',
    height: 'auto',
  },
  'input-filled': {
    margin: 0,
    padding: theme.spacing(1, 2),
  },
  'input-outlined': {
    margin: 0,
    padding: theme.spacing(1.25, 2),
  },
  'input-standard': {
    margin: '-2px 0',
    padding: 0,
  },
  menuItemLabel: {
    display: '-webkit-box',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    wordBreak: 'break-word',
  },
  menuItemRoot: {
    alignItems: 'center',
    whiteSpace: 'normal',
  },
  noOptionsMessage: {
    padding: theme.spacing(1, 2),
  },
  paper: {
    boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)',
    position: 'relative',
    width: '100%',
    zIndex: 11,
  },
  placeholder: {
    // eslint-disable-next-line @typescript-eslint/no-deprecated -- deferred until the MUI upgrade is finished
    color: theme.placeholder,
    fontSize: '16px',
    margin: '0 !important',
    maxWidth: '96%', // Leave room for divider between text & dropdown icon
    overflow: 'hidden',
    padding: 0,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  placeholderFocused: {
    opacity: 0,
    width: 0,
  },
  root: {
    flexGrow: 1,
  },
  singleValue: {
    fontSize: 16,
    maxWidth: '96%', // Leave room for divider between text & dropdown icon
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  valueContainer: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'nowrap',
    overflow: 'hidden',
  },
  wrap: {
    flexWrap: 'initial',
    whiteSpace: 'normal',
  },
} as const satisfies StyleRules);

export default selectStyles;
